import { useEffect, useState } from "react";
import { Sparkles, X, ArrowRight } from "lucide-react";
import { withUtm } from "./utm";
import { useArkemaLang } from "./i18n";
import { trackPostHogEvent } from "@/lib/analytics";

const STORAGE_KEY = "ai_planner_dismissed";

const AIPlannerFloating = () => {
  const { lang, t } = useArkemaLang();
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === "1") {
        setClosed(true);
        return;
      }
    } catch (_) {}

    const timer = window.setTimeout(() => {
      setMounted(true);
      trackPostHogEvent("veolia_ai_assistant_opened", {
        page: "veolia",
        lang,
      });
      // small delay to trigger transition
      window.setTimeout(() => setVisible(true), 30);
    }, 20000);

    return () => window.clearTimeout(timer);
  }, [lang]);

  const handleClose = () => {
    setVisible(false);
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch (_) {}
    window.setTimeout(() => setClosed(true), 300);
  };

  if (closed || !mounted) return null;

  return (
    <div
      className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 w-[calc(100vw-2rem)] sm:w-[360px] transition-all duration-300 ease-out ${
        visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
      }`}
      role="dialog"
      aria-label={t("ai_planner.title")}
    >
      <div className="bg-white rounded-2xl shadow-xl border border-black/10 border-t-4 border-t-[#C6E278] p-4 sm:p-5 relative">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-black px-2.5 py-1 text-[11px] font-semibold text-[#C6E278]">
          <Sparkles className="h-3 w-3" />
          {t("ai_planner.pill")}
        </span>

        <h3 className="mt-3 text-base sm:text-lg font-semibold text-black leading-snug">
          {t("ai_planner.title")}
        </h3>
        <p className="mt-1.5 text-sm text-black/70 leading-relaxed">
          {t("ai_planner.description")}
        </p>

        <a
          href={withUtm("https://ai.ext.naboo.app/", lang)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            trackPostHogEvent("veolia_ai_assistant_cta_clicked", {
              page: "veolia",
              lang,
            })
          }
          className="mt-4 inline-flex w-full items-center justify-center gap-2 bg-cta-green text-black font-semibold rounded-xl px-4 py-2.5 text-sm hover:opacity-90 transition-opacity"
        >
          <Sparkles className="h-4 w-4" />
          {t("ai_planner.cta")}
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default AIPlannerFloating;
